import { render, staticRenderFns } from "./EmploymentInformation.vue?vue&type=template&id=2bafeee4&scoped=true"
import script from "./EmploymentInformation.vue?vue&type=script&lang=js"
export * from "./EmploymentInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bafeee4",
  null
  
)

export default component.exports